define('shared/util/cq/siteCatalyst/eventHijacker/StoresInitialize',['kernel/util/siteCatalyst/StoresInitialize'], function(StoresInitialize){
    return StoresInitialize;
});
